<template>
  <div class="w-full flex flex-row justify-center">
    <div class="w-full flex flex-row max-w-xl">
      <vs-row>
        <vs-col class="p-0 " vs-w="12">
          <vs-tabs alignment="start" color="primary" v-model="activeIndex" :value="activeIndex">
            <vs-tab label="Início" :disabled="isAnonimous" @click="changeRoute" />
            <vs-tab label="Perfil" @click="changeRoute" />
            <vs-tab label="Vagas" @click="changeRoute" />
            <vs-tab label="Reuniões" @click="changeRoute" />
            <vs-tab label="Configurações" @click="changeRoute" />
          </vs-tabs>
          <transition name="slide-fade" mode="out-in">
            <router-view class="dashboard-controll__wrapper"></router-view>
          </transition>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { get } from "lodash";

export default {
  data: () => ({
    path: [
      "dashboard-info",
      "dashboard-profile-detail",
      "dashboard-vacancy",
      "dashboard-meeting",
      "dashboard-settings",
    ]
  }),
  watch: {
    '$route': {
      handler() {
        this.updateActiveIndex();
      },
      immediate: true
    }
  },
  computed: {
    ...mapState("basicInfo", ["basicInfo"]),
    ...mapState("company", ["company"]),

    activeIndex: {
      set(value) {
        this.$store.dispatch("updateTab", value);
      },
      get() {
        return this.$store.state.activeIndex;
      }
    },

    name: {
      get() {
        return this.basicInfo.name || "";
      }
    },

    recruteiBaseTalentIsEnabled() {
      return this.company.has_base_public && this.optimizelyIsEnabled();
    },

    color() {
      return this.company.base_hexcolor || "#1551b1";
    },

    isAnonimous() {
      const label = get(this.$router, "history.current.params.company_label", null);
      return label === "anonima";
    }
  },
  methods: {
    changeRoute() {
      const actualPath = this.$router.history.current.name;
      if (actualPath !== this.path[this.activeIndex]) {
        this.$router.push({
          name: this.path[this.activeIndex]
        });
      }
    },
    optimizelyIsEnabled() {
      const params = this.$router.history.current.params;

      return this.$optimizely.isFeatureEnabled("base_de_talentos", "", {
        slugs: params.company_label
      });
    },
    updateActiveIndex() {
      const currentPath = this.$router.history.current.name;
      const index = this.path.indexOf(currentPath);
      if (index !== -1) {
        this.activeIndex = index;
      }
    }
  },
};
</script>

<style lang="scss">
.dashboard {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  color: white;
}

.dashboard--title {
  color: white;
  text-align: center;

  @media screen and (max-width: 578px) {
    font-size: 1.5em;
  }
}

.dashboard-controll__wrapper {
  max-width: 90%;
  margin: 0 auto;

  @media screen and (min-width: 768px) {
    max-width: 100%;
  }
}
</style>
